import { useRef, useEffect } from "react";

type OperationResult = {
	loading: boolean;
	called: boolean;
	error?: unknown;
	data?: unknown;
};

/**
 * @deprecated Use Apollo's `useMutation` hook with the `onCompleted` option instead.
 */
export default function useMutationOnSuccess<
	Execute,
	Result extends OperationResult,
>(
	onSuccess: (data: Result["data"]) => void,
	[execute, result]: readonly [Execute, Result],
): readonly [Execute, Result] {
	const { loading, error, called, data } = result;
	const callback = useRef(onSuccess);
	const hasSucceeded = !loading && called && !error;

	useEffect(() => {
		if (hasSucceeded) {
			callback.current(data);
		}
	}, [hasSucceeded, data]);

	useEffect(() => {
		callback.current = onSuccess;
	}, [onSuccess]);

	return [execute, { ...result }] as const;
}
